import React, { Component } from 'react'

import css from './style.module.css'

const today = new Date()

export default class Calendar extends Component {

    constructor(props) {
        super(props)

        let date = new Date()
        this.state = {
            y: date.getFullYear(),
            m: date.getMonth(),
            d: 1,
            calendar: []
        }
    }

    componentDidMount() {
        this.generateCalendar()
    }

    generateCalendar() {
        this.setState(state => ({
            calendar: generateCalendarMatrix(state.y, state.m, state.d)
        }))
    }

    setMonth(m) {
        let y = this.state.y
        if(m < 0) {
            m = 11
            y = y - 1
        }

        if(m > 11) {
            m = 0
            y = y + 1
        }

        this.setState({
            m,
            y
        })
        this.generateCalendar()
    }

    nextMonth() {
        this.setMonth(this.state.m + 1)
    }

    prevMonth() {
        this.setMonth(this.state.m - 1)
    }

    classDate(y, m, d) {
        let date = formatStringDate(y, m, d)

        if(this.props.justNextDays && toDate(y, m, d).getTime() < (today.getTime() - 86400000))
        return css.disabledDate
        
        if(this.props.currentDate === date)
        return css.current

        if(this.props.dates.indexOf(date) > -1)
        return css.marked
    }

    setDate(y, m, d) {
        if(!this.props.handleSetDate) return;

        let date = formatStringDate(y, m, d)
        this.props.handleSetDate(date)
    }

    render() {
        const { y, m, calendar } = this.state
        
        return (
            <div className={[css.boxCalendar, this.props.theme ? css[`theme-${this.props.theme}`] : null, this.props.disabled ? css.disabled : null].join(' ')} {...this.props.style}>
                <div className={css.headerCalendar}>
                    <span className={css.headerTitle}>{MonthLabel[this.state.m]} {this.state.y}</span>
                    <div className={css.arrows}>
                        <span className={css.icon} onClick={() => this.prevMonth()}> {this.props.prevIcon()} </span>
                        <span className={css.icon} onClick={() => this.nextMonth()}> {this.props.nextIcon()} </span>
                    </div>
                </div>
                <table className={css.calendar}>
                    <thead>
                        <tr>
                            <th>D</th>
                            <th>S</th>
                            <th>T</th>
                            <th>Q</th>
                            <th>Q</th>
                            <th>S</th>
                            <th>S</th>
                        </tr>
                    </thead>
                    <tbody>
                        {calendar.map((week, wk) => (
                            <tr key={wk}>
                                {week.map((d, k) => (
                                    <td key={k}>
                                        <span
                                            className={this.classDate(y, m, d)}
                                            onClick={() => this.setDate(y, m, d)}>
                                                {d}
                                        </span>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

function chunk (arr, size) {
    return arr.reduce((chunks, el, i) => {
        if (i % size === 0) {
            chunks.push([el])
        } else {
            chunks[chunks.length - 1].push(el)
        }
        return chunks
    }, [])
}

let dayMonth = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

let MonthLabel = [
    'Janeiro',
    'Fevereio',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
]

function generateCalendarMatrix(y, m, d) {
    let calendar = []
    let date = new Date(y, m, d)
    let isB = date.getFullYear() % 4 === 0 ?  true : false
    let ds = date.getDay()
    let month = date.getMonth()

    for (let i = 0; i < ds; i++) {
        calendar.push(null)
    }
    
    if(isB) dayMonth[1] = 29
    else dayMonth[1] = 28

    let days = dayMonth[month]

    for (let i = 1; i <= days; i++) {
        calendar.push(i)
    }

    calendar = chunk(calendar, 7)

    return calendar
}

function formatStringDate(y, m, d) {
    m = m+1
    d = d < 10 ? `0${d}` : d
    m = m < 10 ? `0${m}` : m
    return `${y}-${m}-${d}`
}

function toDate(y, m, d) {
    return new Date(y, m, d)
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/molecules/Calendar/index.js